require('./overrides.sass');

const preset = {
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#F57C00',
        secondary: '#455A64',
        accent: '#FF5722',
        error: '#D50000',
        info: '#01579B',
        success: '#757575',
        warning: '#000',
      },
      dark: {
        primary: '#F57C00',
        secondary: '#252525',
        accent: '#000',
        error: '#D50000',
        info: '#01579B',
        success: '#757575',
        warning: '#FF5722',
      },
    },
  },
};

module.exports = { preset };
